import DragHandle from '../control/DragHandle'

const CuratedTopic = (props) => <div className={'curated-topic-row'}>
  <div className={'btn btn-default curated-topic-title'}><DragHandle /> {props.title}</div>
  <div className={'open-external'}>
    <a href={props.url} target={'_blank'} className={'btn btn-default open-external full-width'}>
      <span className={'icon icon-open-external'} />
    </a>
  </div>
  <div onClick={props.onDelete} className={'btn btn-danger'}>{'Remove'}</div>
</div>

export default CuratedTopic
